import { createPortal } from "react-dom";

export const MenuWithPortal = ({ children }) => {
  return createPortal(children, document.body);
};
